import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const MessagesContext = createContext();

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const MessagesProvider = ({ children }) => {
  const [unreadCount, setUnreadCount] = useState(0);

  const fetchUnreadCount = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setUnreadCount(0);
        return;
      }

      const response = await axios.get(`${API_URL}/api/conversations`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      // Calculate total unread count from all conversations
      const total = response.data.reduce((sum, conv) => {
        const unread = conv.unread_count || 0;
        return sum + unread;
      }, 0);

      setUnreadCount(total);
    } catch (error) {
      console.error('Error fetching unread count:', error);
      setUnreadCount(0);
    }
  };

  useEffect(() => {
    fetchUnreadCount();
    
    // Poll for unread count every 30 seconds
    const interval = setInterval(fetchUnreadCount, 30000);
    
    return () => clearInterval(interval);
  }, []);

  return (
    <MessagesContext.Provider value={{ unreadCount, setUnreadCount, fetchUnreadCount }}>
      {children}
    </MessagesContext.Provider>
  );
};

export const useMessages = () => {
  const context = useContext(MessagesContext);
  if (!context) {
    throw new Error('useMessages must be used within a MessagesProvider');
  }
  return context;
};
